import * as CL from '@design-system/component-library';
import { useOutletContext } from 'react-router';
import { Table } from '../OpenFormHooks/useTable.js';
import { type OpenFormOutlet } from '../OpenFormLayout/OpenFormLayoutOutlet.js';
import { useOpenFormState } from '../OpenFormProvider.js';
import { OpenFormButton } from './OpenFormButton.js';
import { OpenFormIcon } from './OpenFormIcon.js';

export type OpenFormIndicator = {
  disable?: boolean;
  message?: string | boolean;
};

export const OpenFormLoadingIndicator = ({ indicator }: { indicator?: OpenFormIndicator }) => {
  const { account, reload, title } = useOutletContext<OpenFormOutlet>() ?? {};
  const { disabled, indicators } = useOpenFormState();
  const { disable, message } = indicator ?? Array.from(indicators.values()).sort(Table.compare('disable'))[0] ?? {};
  return (
    <div className="of-openform__title__content__center">
      {!message ? (
        <div className="of-openform__title__content__center__logo">
          <CL.Logo aria-disabled={disabled || disable} />
          {!self.location.hostname.endsWith('yrityksille.elisa.fi') && <pre>{self.location.hostname}</pre>}
        </div>
      ) : (
        <div className="of-openform__title__content__center__load">
          {message !== true && <span className="of-openform__title__content__center__load__text">{message}</span>}
          <CL.LoadingSpinner className="of-openform__title__content__center__load__spinner" size="l" />
        </div>
      )}
      <div className="of-openform__title__content__center__name" aria-disabled={disabled || disable}>
        {!account ? null : (
          <>
            <span className="of-openform__title__content__center__name__account">
              {account.header.accountName}
              <OpenFormButton
                icon={<OpenFormIcon icon="update" />}
                color="link"
                size="s"
                disabled={disabled || disable || !reload}
                onClick={reload}
              />
            </span>
            <span className="of-openform__title__content__center__name__title">{title?.() ?? <>&nbsp;</>}</span>
          </>
        )}
      </div>
    </div>
  );
};
